<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar flat color="white">
      <v-toolbar-title>Nagad Cashout Pending</v-toolbar-title>
      <!-- <v-divider
          class="mx-2"
          inset
          vertical
        ></v-divider> -->
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
        @keyup.enter="paginationMethod"
      ></v-text-field>
      <v-spacer></v-spacer>
      <!-- view page start here -->
      <v-dialog v-model="dialog">
        <template>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-card>
                <v-card-text>
                  <v-card-title class="indigo white--text">
                    <div class="headline">Dasher Profile Information</div>
                  </v-card-title>
                  <!-- <v-img
                      class="my-3"
                      contain
                      aspect-ratio="2"
                    >
                    
                      <v-layout
                        column
                        fill-height
                      >
                        <v-spacer></v-spacer>

                        <v-card-title class="gray--text pl-5 pt-5">
                          <div class="display-1 pl-5 pt-5"><span class="green--text">{{editedItem.name}}</span></div>
                        </v-card-title>
                      </v-layout>
                    </v-img> -->

                  <v-list two-line>
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon color="indigo">phone</v-icon>
                        <!-- <v-icon color="indigo">mail</v-icon> -->
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{ editedItem.phone }}
                        </v-list-tile-title>
                        <!-- <v-list-tile-title>{{editedItem.email}}</v-list-tile-title> -->
                      </v-list-tile-content>

                      <v-list-tile-action>
                        <v-icon color="indigo" v-if="editedItem.active == 1">
                          radio_button_checked
                        </v-icon>
                        <v-icon color="indigo" v-else>
                          radio_button_unchecked
                        </v-icon>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title>Active</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-divider inset></v-divider>
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon color="indigo">location_on</v-icon>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title>address</v-list-tile-title>
                        <v-list-tile-sub-title
                          v-if="editedItem.address != null"
                        >
                          {{ editedItem.address }}
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                  <v-card-title class="indigo white--text">
                    <div class="headline">Coin & Point Details</div>
                  </v-card-title>
                  <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        Total Coin
                      </v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        {{ editedItem.total_coin }}
                      </v-subheader>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        Total Point
                      </v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        {{ editedItem.total_point }}
                      </v-subheader>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        Ranking Level
                      </v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        {{ editedItem.level }}
                      </v-subheader>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        Ranking Name
                      </v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        {{ editedItem.rank_name }}
                      </v-subheader>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        Mobile Number
                      </v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        {{ editedItem.account_number }}
                      </v-subheader>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        Request Amount
                      </v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">
                        {{ editedItem.withdraw_amount }}
                      </v-subheader>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              <v-list-tile-title class="font-weight-bold text-sm-center">
                Rejection Comments
              </v-list-tile-title>
              <v-layout row justify-space-around>
                <v-flex xs12>
                  <v-card>
                    <v-card-text class="px-1">
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-textarea
                          v-model="commentData.comment"
                          :rules="[(v) => !!v || 'This field is required']"
                          label="Comment here, why are you rejecting this request?"
                          box
                          required
                        ></v-textarea>
                      </v-form>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <!-- <v-divider inset></v-divider> -->
          <v-container fluid>
            <v-layout row>
              <div>
                <v-btn color="success" @click="verifyItem(editedItem)">
                  Accept
                </v-btn>
                <v-btn color="warning" @click="rejectItem(editedItem)">
                  Reject
                </v-btn>
                <v-btn color="red" @click="close">Close</v-btn>
              </div>
            </v-layout>
          </v-container>
        </template>
      </v-dialog>
      <!-- view page end here -->
    </v-toolbar>
    <div v-if="isLoaded">
      <div v-if="alertMsg">
        <v-alert
          v-if="error == 0 && statusCode == 200"
          :value="true"
          type="success"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
        <v-alert
          v-if="error == 1 && statusCode == 204"
          :value="true"
          type="info"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
        <v-alert
          v-if="error == 1 && (statusCode == 403 || statusCode == 400)"
          :value="true"
          type="warning"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
        <v-alert
          v-if="error == 1 && statusCode == 500"
          :value="true"
          type="error"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
      </div>
      <div v-if="indexData.dataset1.total < 1" class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <v-data-table
        :headers="headers"
        :items="indexData.dataset1.data"
        :search="search"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :loading="loading"
        class="elevation-1"
      >
        <v-progress-linear color="blue" indeterminate></v-progress-linear>
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ props.header.text }}
              </span>
            </template>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>

        <template v-if="indexData.dataset1.total > 0" v-slot:items="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.user_id }}</td>
          <td>{{ props.item.withdraw_amount }}</td>
          <td>{{ props.item.account_number }}</td>
          <td>{{ props.item.full_name }}</td>
          <td>{{ props.item.message }}</td>
          <td>{{ props.item.created_att }}</td>
          <td class="justify-center layout px-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="mr-2"
                  v-on="on"
                  @click="checkItem(props.item)"
                >
                  visibility
                </v-icon>
              </template>
              <span>view</span>
            </v-tooltip>
          </td>
        </template>
        <template v-else v-slot:no-data>
          <v-alert :value="true" color="error" icon="warning">
            {{ errorMsg }}
          </v-alert>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
        <template v-slot:pageText>
          Rows {{ indexData.dataset1.from }} - {{ indexData.dataset1.to }} of
          {{ indexData.dataset1.total }}
        </template>
      </v-data-table>
      <template>
        <div class="text-xs-center">
          <v-layout wrap>
            <v-flex xs10 sm10 md10>
              <v-pagination
                right
                v-model="indexData.dataset1.current_page"
                :length="indexData.dataset1.last_page"
                @input="onPageChange"
              ></v-pagination>
            </v-flex>
          </v-layout>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    data: () => ({
      dialog: false,
      alertMsg: false,
      apiUrl: "nagad-cashout-list",
      valid: true,
      sl: 1,
      headers: [
        { text: "ID", align: "left", value: "id" },
        { text: "Dasher ID", align: "left", value: "user_id" },
        { text: "Request Amount", align: "left", value: "withdraw_amount" },
        { text: "Nagad Number", value: "account_number" },
        { text: "Dasher Name", value: "full_name" },
        { text: "Message", value: "message" },
        { text: "Submitted at", value: "created_at" },
        { text: "Actions", align: "center", value: "name", sortable: false },
      ],
      loading: false,
      search: "",
      pagination: {
        rowsPerPage: 10,
      },
      rowsPerPageItems: [10, 20, 50, 100, 200, 500],
      editedIndex: -1,
      editedItem: {},
      commentData: {
        id: null,
        comment: null,
      },
      defaultItem: {
        rowsPerPage: 10,
      },
    }),

    computed: {
      ...mapGetters([
        "isLoggedIn",
        "indexData",
        "error",
        "statusCode",
        "errorMsg",
      ]),
      isLoaded() {
        if (this.indexData.dataset1) {
          return true;
        } else {
          return false;
        }
      },
    },

    watch: {
      pagination() {
        this.onPageChange();
      },
      dialog(val) {
        val || this.close();
      },
    },

    created() {
      this.reloading();
    },

    methods: {
      reloading() {
        this.$store.dispatch("changeWithdrawStatus", [
          this.apiUrl,
          1,
          "",
          1,
          this.pagination.rowsPerPage,
        ]);
      },
      initialize() {
        this.paginationMethod();

        // this.alertMsg = true
        // setTimeout(() => {
        //   this.alertMsg = false
        // }, 300)
      },

      setErrorZero() {
        this.$store.dispatch("setErrorZero");
      },

      // search(){
      //   console.log(this.search);
      // },

      checkItem(item) {
        this.commentData.id = null;
        this.commentData.comment = null;
        this.editedIndex = this.indexData.dataset1.data.indexOf(item);
        this.editedItem = Object.assign([], item);
        this.dialog = true;
      },

      verifyItem(item) {
        // console.log(item)
        var popUpMsg = confirm("Are you sure want to accept this application?");
        if (popUpMsg) {
          this.$store.dispatch("changeWithdrawStatus", [
            "nagad-cashout-accept",
            item.id,
            "",
            1,
            this.pagination.rowsPerPage,
          ]);
        }
        this.reloading();
        this.close();
      },

      rejectItem(item) {
        this.commentData.id = item.id;
        if (this.$refs.form.validate()) {
          var popUpMsg = confirm(
            "Are you sure want to reject this application?"
          );
          if (popUpMsg) {
            this.$store.dispatch("updateRequest", [
              "nagad-cashout-reject",
              this.commentData,
            ]);
          }
          this.reloading();
          this.close();
        }
      },

      close() {
        this.dialog = false;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },

      onPageChange() {
        this.paginationMethod();
      },

      paginationMethod() {
        this.loading = true;
        if (this.search) {
          this.pagination.rowsPerPage = 1000;
          this.$store.dispatch("changeWithdrawStatus", [
            this.apiUrl,
            1,
            this.search,
            this.indexData.current_page,
            this.pagination.rowsPerPage,
          ]);
          this.loading = this.indexData.dataset1.data ? false : true;
        } else {
          if (this.pagination.rowsPerPage == 1000) {
            this.pagination.rowsPerPage = 10;
          }
          this.$store.dispatch("changeWithdrawStatus", [
            this.apiUrl,
            1,
            "",
            this.indexData.dataset1.current_page,
            this.pagination.rowsPerPage,
          ]);
          this.loading = !this.indexData.dataset1.error ? false : true;
        }
        this.dialog = false;
      },
    },
  };
</script>
<style lang="stylus" scoped>
  .v-progress-circular
    margin: 1rem

  .imageResize
    width: auto
    height: auto
</style>
